export const driver = {
  newDriver: "New Driver",
  editDriver: "Edit Driver",
  driveDetails: "Driver Details",
  useFaceIDPhoto: "Use Face ID Photo",
  userSameEmailAddress: "A user is registered under the same Email address. ",
  // Format: type ["detail1", "detail2", ......]
  deleteTip:
    "The driver {0} will be deleted. Are you sure you want to proceed? | The drivers {0} will be deleted. Are you sure you want to proceed?",
};
